








import { Component, Vue, Emit } from 'vue-property-decorator';
import {ALL_CARS } from '@/queries/Car';
import CarForm from '@/components/Car/CarForm.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_currentUnitCars } from '@/queries/__generated__/currentUnitCars';
import { GQL_createCar } from '@/queries/__generated__/createCar';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit } from '@/queries/__generated__/currentUnit';
import { SmartQuery } from 'vue-apollo-decorator';
import gql from 'graphql-tag';

const CREATE_CAR = gql`
  mutation createCar(
    $unitId: ID!,
    $name: String!,
    $norwegianListPriceAsNew: Decimal,
    $registrationNumber: String!,
  ) {
    createCar(
      input: {
        car: {
          unitId: $unitId,
          name: $name,
          norwegianListPriceAsNew: $norwegianListPriceAsNew,
          registrationNumber: $registrationNumber
        }
      }
    ) {
      car {
        id
        name
        norwegianListPriceAsNew
        registrationNumber
      }
    }
  },
`;

@Component({
  components: {
    CarForm,
  },
})
export default class CarNew extends Vue {
  @SmartQuery<CarNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.data.unitId = data.currentUnit.id;
    },
  }) public currentUnit!: GQL_currentUnit;

  public CREATE_CAR = CREATE_CAR;
  public data = {
    unitId: '',
    name: null,
    norwegianListPriceAsNew: null,
    registrationNumber: null,
  };

  @Emit('car-created')
  public addToCache(store: InMemoryCache, query: {data: GQL_createCar }) {
    const data = (store.readQuery({ query: ALL_CARS }) as GQL_currentUnitCars);
    if (!data.currentUnit || !query.data.createCar?.car) return;
    const car = query.data.createCar!.car!;
    data.currentUnit.cars.push(car);
    store.writeQuery({ query: ALL_CARS, data });
    return car;
  }
}
